import React, { useEffect, useMemo, useState } from 'react';
import Application from '../../Application';

const MuteToggle: React.FC = () => {
    const app = useMemo(() => new Application(), []);
    const [muted, setMuted] = useState(false);
    const [modelFreeMode, setModelFreeMode] = useState(false);

    useEffect(() => {
        setMuted(app.audio.isMuted());

        const onMuted = (...args: unknown[]) => setMuted(Boolean(args[0]));
        app.audio.on('muted', onMuted);
        return () => {
            app.audio.off('muted', onMuted);
        };
    }, [app]);

    useEffect(() => {
        const sync = () => {
            setModelFreeMode(Boolean(app.world?.isModelFreeMode()));
        };
        sync();

        const observer = new MutationObserver(sync);
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        return () => observer.disconnect();
    }, [app]);

    const toggle = () => {
        app.audio.setMuted(!muted);
        setMuted(!muted);
    };

    if (modelFreeMode) return null;

    return (
        <button
            onClick={toggle}
            style={{
                position: 'fixed',
                bottom: 46,
                right: 16,
                width: 44,
                height: 44,
                background: '#c0c0c0',
                border: 'none',
                boxShadow: 'inset -1px -1px #2b2b2b, inset 1px 1px #fff, inset -2px -2px #808080, inset 2px 2px #c0c0c0',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 22,
                zIndex: 99997,
            }}
            title={muted ? '取消静音' : '静音'}
        >
            {muted ? '🔇' : '🔊'}
        </button>
    );
};

export default MuteToggle;
